export const currenciesConfig = {
  headings: [
    {
      headingLabel: "Inactive",
      icon: "",
      width: "10%",
      inputType: "checkbox",
    },
    {
      headingLabel: "Language",
      icon: "",
      inputType: "text",
      width: "35%",
    },
    {
      headingLabel: "Version",
      icon: "",
      inputType: "text",
      width: "30%",
    },
    {
      headingLabel: "Created On",
      icon: "",
      inputType: "text",
      width: "20%",
    },
  ],
  dataNodes: ["is_active", "language", "version", "created_at"],
  primaryKey: "currency_id",
  actions: ["pen", "times"],
  nodeFields: [
    {
      column: "is_active",
      icon: "check",
    },
  ],
  buttonFields: [
    {
      column: "",
      icon: "pen",
    },
  ],
  inlineEdits: [
    {
      dataNode: "is_active",
      width: "9%",
    },
    {
      dataNode: "language",
      width: "20%",
      isMandatory: true,
    },
    {
      dataNode: "version",
      width: "65%",
      isMandatory: true,
    },
  ],
};
export const currencyList = [
  {
    inactive: " ",
    code: "1000",
    description: "[Description]",
    id: 1,
  },
  {
    inactive: " ",
    code: "1000",
    description: "[Description]",
    id: 2,
  },
  {
    inactive: " ",
    code: "1000",
    description: "[Description]",
    id: 3,
  },
  {
    inactive: "yes",
    code: "1000",
    description: "[Description]",
    id: 4,
  },
  {
    inactive: " ",
    code: "1000",
    description: "[Description]",
    id: 5,
  },
  {
    inactive: " ",
    code: "1000",
    description: "[Description]",
    id: 6,
  },
  {
    inactive: " ",
    code: "1000",
    description: "[Description]",
    id: 7,
  },
  {
    inactive: " ",
    code: "1000",
    description: "[Description]",
    id: 8,
  },
];
